import { APPLICATIONS as applications } from './applications';

export const REPORTS = {
  applications
};
